import { useEffect } from 'react';
const organization = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': 'https://www.robertsonprecision.com/#organization',
  name: 'Robertson Precision, Inc.',
  url: 'https://www.robertsonprecision.com/',
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'sales',
    telephone: '+1-800-397-7745',
    email: 'sales@sheargeometry.com'
  }
};
const website = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': 'https://www.robertsonprecision.com/#website',
  url: 'https://www.robertsonprecision.com/',
  name: 'Robertson Precision',
  publisher: {
    '@id': 'https://www.robertsonprecision.com/#organization'
  }
};

/**
 * Injects the two approved JSON-LD graphs into <head> once per mount.
 */
export function StructuredData() {
  useEffect(() => {
    const nodes = [organization, website].map((data, i) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = `rp-jsonld-${i}`;
      script.text = JSON.stringify(data);
      document.head.appendChild(script);
      return script;
    });
    return () => {
      nodes.forEach(n => n.remove());
    };
  }, []);
  return null;
}